import React, {useState} from 'react';
import PlacesAutocomplete from "react-places-autocomplete";
import PortalMapPicker from '../MapPicker';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLocationDot} from "@fortawesome/free-solid-svg-icons";

const DefaultLocation = {lat: 33.87037955285725, lng: 35.52310841126815};
const DefaultZoom = 12;

function AddressInput({portalBranchDTO, setPortalBranchDTO}) {
    const [defaultLocation, setDefaultLocation] = useState(DefaultLocation);
    const [zoom, setZoom] = useState(DefaultZoom);

    function handleChangeLocation(lat, lng) {
        setPortalBranchDTO((prevState) => ({
            ...prevState,
            Latitude: lat,
            Longitude: lng,
        }));
    }

    const handleChangeDescription = (address) => {
        setPortalBranchDTO((prevState)=> ({
        ...prevState,
        Description: address
        }));
    }

    function handleChangeZoom(newZoom) {
        setZoom(newZoom);
    }

    return (
        <div className="row component">
            <div className="col-lg-12 subTitle">Branch Address</div>
            <PlacesAutocomplete
                value={portalBranchDTO.Description}
                onChange={
                    (e) => setPortalBranchDTO((prevState) => ({
                        ...prevState,
                        Description: e,
                    }))
                }
                onSelect={(address, placeId) => {
                    handleChangeDescription(address);
                }}
            >
                {({getInputProps, suggestions, getSuggestionItemProps, loading}) => (
                    <div className="places-div">
                        <input
                            {...getInputProps({
                                placeholder: "Street, building, city, country",
                                className: "form-control places-input",
                            })}
                        />
                        <FontAwesomeIcon className="faLocation" icon={faLocationDot} />
                        {/*<img src="/Images/pin.png"/>*/}

                        <div className="autocomplete-dropdown-container">
                            {loading && <div>Loading...</div>}
                            {suggestions.map((suggestion) => {
                                const className = suggestion.active
                                    ? "suggestion-item--active"
                                    : "suggestion-item";
                                const style = suggestion.active
                                    ? {backgroundColor: "#fafafa", cursor: "pointer"}
                                    : {backgroundColor: "#ffffff", cursor: "pointer"};
                                return (
                                    <div
                                        {...getSuggestionItemProps(suggestion, {
                                            className,
                                            style,
                                        })}
                                    >
                                        <span>{suggestion.description}</span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </PlacesAutocomplete>
            <div className="map">
               <PortalMapPicker
                handleChangeLocation={handleChangeLocation}
                handleChangeZoom={handleChangeZoom}
                zoom={zoom}
                defaultLocation={defaultLocation}
               />
               {/*apiKey='AIzaSyD07E1VvpsN_0FvsmKAj4nK9GnLq-9jtj8'/>*/}
            </div>

        </div>
    );
}

export default AddressInput;